module.exports = __webpack_public_path__ + "static/media/ste_wor_acc.b6b28771.png";